const autoNgTemplateLoaderTemplate1 = require('./create-user-access-token.html');

import angular from 'angular';
import controller from './create-user-access-token.controller';

angular.module('shbdeployer.app').component('createUserAccessToken', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
});
